import React, { isValidElement, useState } from 'react';
import CommonService from '../../../../services/commonService';

import getIcons from '../../functions/getIcons/getIcons';

const SanAndreasHeader = ({ operator, t, history , onMyAccountClick, loginData}) => {
  let links = [];

  for (let i = 0; i < operator.header_links.length; i++) {
    let obj = operator.header_links[i];
    for (let [key, value] of Object.entries(obj)) {
      if (typeof value === 'string') {
        links.push({
          label: key,
          link: value,
        });
      } else if (Array.isArray(value)) {
        let temp = [];
        for (let j = 0; j < value.length; j++) {
          let obj2 = value[j];
          for (let [key1, value1] of Object.entries(obj2)) {
            temp.push({
              label: key1,
              link: value1,
            });
          }
        }
        links.push({
          label: key,
          link: '',
          subLinks: temp,
        });
      }
    }
  }

  const [nav, setNav] = useState(links ? links[0].label : '');
  const [subNav, setSubNav] = useState('');

  console.log('link', links, subNav);

  return (
    <div>
      <style>
        .nav-section.home-nav-section.common-top-strip.header-box + * {'{'}
        margin-top:260px
        {'}'}
        .nav-section.home-nav-section.common-top-strip.header-box.payments-page-header + * {'{'}
        margin-top:165px !important
        {'}'}
      </style>
      <div
        style={{
          background:
            operator && operator.color_codes && operator.color_codes.sub_header_color
              ? operator.color_codes.sub_header_color
              : '',
          color: operator && operator.text_color,
          padding: '2px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div
          className="new-container"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div className="font-14px pullman-bold-text">
             En este verano, Pullman San Andrés uniendo familias por el norte de Chile.
          </div>
          <div style={{ fontSize: '13px', display: 'flex', alignItems: 'center' }}>
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <a href="https://www.facebook.com/pullmansanandres.cl" target="_black">
                <span className="san-andreas-facebook mx-1"></span>
              </a>
              <a href="https://www.instagram.com/pullmansanandres.cl/" target="_black">
                <span className="san-andreas-insta mx-1"></span>
              </a>
              <span className="mx-1">|</span>
              <a href="https://api.whatsapp.com/send?phone=56933798168" target="_blank">
                {/* <span className="san-andreas-whatsapp mx-1"></span> */}
                <img src={getIcons('whatsAppIcon', operator)} style={{width:20,height:20, marginRight:5}} />

              </a>

              <span className="font-17px">{operator.phone_number}</span>
            </span>
          </div>
        </div>
      </div>
      <div
        style={{
          background:
            operator && operator.color_codes && operator.color_codes.header_color
              ? operator.color_codes.header_color
              : '',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          paddingTop: '10px',
          minHeight: '80px',
        }}
      >
        <div
          className="new-container"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <a href="/">
            <img
              src={operator.header_logo}
              alt="DIS"
              className="logo2"
              id="main-logo"
              style={{ width: operator.header_logo_width }}
            />
          </a>
          <div>
            <style>
              a.header_link {'{'}
              {/* border-bottom: 2px; */}
              {/* font-family:  Montserrat_Bold !important; */}
              {'}'}
              a.header_link:hover {'{'}
              border-bottom: 2px solid{' '}
              {operator && operator.button_color ? operator.button_color : ''};
              {/* font-family: Montserrat_SemiBold !important */}
              {'}'}
            </style>

            <div className="d-flex">
              {operator && operator.header_links
                ? links.map((val, i) => {
                  return (
                    <div className="px-3">
                      <div
                        className="mb-2"
                        onClick={() => {
                          if (val.link) {
                            setNav(val.label);
                            history.push(val.link);
                          }
                        }}
                      >
                        <span
                          className="text-white font-17px pullman-bold-text text-uppercase cursor-pointer font-weight-bold"
                          style={{
                            borderBottom:
                              window.location.pathname == val.link && nav === val.label
                                ? '2px solid white'
                                : '',
                          }}
                        >
                          {val.label}
                        </span>
                      </div>
                      <div className="d-flex flex-column">
                        {val.subLinks &&
                          val.subLinks.map(subLink => {
                            return (
                              <div
                                className="font8 cursor-pointer "
                                style={{
                                  width: 'fit-content',
                                  paddingBottom: 1,
                                  marginBottom: 7,
                                  borderBottom:
                                    window.location.pathname == subLink.link
                                      ? '2px solid white'
                                      : '',
                                }}
                                onClick={() => {
                                  setSubNav(subLink.label);
                                  history.push(subLink.link);
                                }}
                              >
                                <span className="text-white ">{subLink.label}</span>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  );
                }


                )
                : null}

              {operator && operator.has_user_account && (
                <ul
                // className="header-login-icon-container"
                >
                  <li>
                    <div className="my-account-top font10">
                      <a onClick={onMyAccountClick}>
                        {CommonService.isLoggedIn(loginData) && loginData.image_link ? (
                          <div className="dp-image-top">
                            <img src={loginData.image_link} alt="DIS" />
                          </div>
                        ) : (
                          <div
                            className={
                              'menu-profile-icon-stripe circular-icon-stripe profile-circular-icon '
                            }
                          >
                            <img
                              src={getIcons('userIcon', operator)}
                              // src="/static/images/user_red_dot.svg"
                              alt={t('TRANSLATIONS.USER_DOT')}
                            />
                          </div>
                        )}
                        {/* {CommonService.isLoggedIn(this.props.common.loginData)
                          ? CommonService.capitalize(this.props.common.loginData.name)
                          : t('HOME.MY_ACCOUNT')} */}
                      </a>
                      {/* {this.state.showMyAccountDropDown ? this.renderMyAccountDropdown(t) : null} */}
                    </div>
                  </li>
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SanAndreasHeader;



// WEBPACK FOOTER //
// ./src/features/themes/common/header/Header6.js